import './icon.css';

export function Icon(props) {
    const clicked = () => {
        if (props.clicked) {
            props.clicked();
        }
    };

    const className = props.class ? props.class : "";
    const clickable = props.clicked ? "clickable" : "";

    return (
        <svg className={`icon ${clickable} ${className}`} onClick={() => clicked()}>
            <use href={`/icons/${props.name}.svg#src`} />
        </svg>
    );
}